// Typology hierarchies reconstructed from the two wheel diagrams + CSV labels.
// Each main category has a color and sub-categories matching the wheel sectors.

export const ACTIVITY_TYPOLOGY = [
  {
    name: "Activism & Advocacy",
    color: "#F5A8A8",
    sub: [
      "Campaigning & Public Engagement",
      "Policy Advocacy & Lobbying",
      "Legal Action & Litigation",
    ],
  },
  {
    name: "Demonstration",
    color: "#FFB98A",
    sub: [
      "Enterprise & Asset Development",
      "Prototyping New Services",
      "Ideation & Concepting",
      "Creating Demonstration Projects",
    ],
  },
  {
    name: "Scaling & Diffusing",
    color: "#F7C6A1",
    sub: [
      "Knowledge Dissemination & Toolkit Development",
      "Model Replication & Adaptation",
      "Scaling Through Partnerships & Institutional Adoption",
    ],
  },
  {
    name: "Communications & Narrative Change",
    color: "#FFD97A",
    sub: [
      "Arts & Cultural Action",
      "Strategic Communications",
      "Futures Thinking & Visioning",
      "Media & Publications",
      "Framework & Narrative Building",
    ],
  },
  {
    name: "Research & Knowledge Generation",
    color: "#FFE8A3",
    sub: [
      "Monitoring Progress",
      "Institutional Research",
      "Grassroots Research",
    ],
  },
  {
    name: "Funding & Resource Mobilisation",
    color: "#FFCFD8",
    sub: [
      "Impact Investing",
      "Regranting & Pooling Funds",
      "Non-financial Resource Sharing",
      "Grantmaking & Philanthropic Funding",
      "Mobilising Public Funding & Subsidies",
    ],
  },
  {
    name: "Capacity Building & Education",
    color: "#F2BEDB",
    sub: [
      "Professional Education & Development",
      "Grassroots Education & Training",
      "Changing Curricula",
      "Technical Services",
    ],
  },
  {
    name: "Movement Building & Organising",
    color: "#FFE0A8",
    sub: [
      "Grassroots Organising & Power Building",
      "Strategy Development",
      "Coalition Building",
      "Orchestration",
    ],
  },
];

export const THEME_TYPOLOGY = [
  {
    name: "Alternative Economic Models",
    color: "#CDC7F0",
    sub: [
      "Pluriversal & Indigenous Economic Paradigms",
      "Ecological Economics & Science-Based Frameworks",
      "Sufficiency & Post-Growth Paradigms",
      "Social Solidarity Economics",
    ],
  },
  {
    name: "Public Finance & Financial System Reform",
    color: "#B8E0C8",
    sub: [
      "Taxation & Tax Justice",
      "Monetary System Reform",
      "Fiscal Policy & Price Rules",
      "Public Investment / Wealth & Asset Stewardship",
      "Global Financial Architecture Reform",
      "Fiscal Policy & Taxation",
      "Financial Market Governance",
    ],
  },
  {
    name: "Socio-Economic Security & Justice",
    color: "#9BD3B8",
    sub: [
      "Decolonial Futures",
      "Care Systems",
      "Universal Basic Services",
      "Universal Income Systems",
      "Work & Labour Futures",
    ],
  },
  {
    name: "Sectoral System Transformation",
    color: "#A3D8E8",
    sub: [
      "Information Technology",
      "Energy",
      "Housing & the Built Environment",
      "Mobility & Transportation",
      "Food & Land Use",
      "Water",
    ],
  },
  {
    name: "Place-Based Resilience",
    color: "#C3E5A8",
    sub: [
      "Regional Transitions",
      "Climate Adaptation & Resilience",
      "Ecosystem Governance & Regeneration",
      "Community-led Transitions",
    ],
  },
  {
    name: "Market Governance & Oversight",
    color: "#D6E8A8",
    sub: [
      "Price & Market Regulation",
      "Industrial Policy & Sectoral Governance",
      "Institutional Investment Governance",
      "Consumer Rights & Protections",
      "Equitable Trade Systems",
      "Corporate Power Dynamics",
    ],
  },
  {
    name: "Democratic Participation & Economic Democracy",
    color: "#B8E4DC",
    sub: [
      "Worker Rights & Infrastructure",
      "Digital Social Utilities",
      "Participatory Organising Models",
      "Commons-based Resource & Consumption",
      "Alternative Ownership & Governance Models",
      "Rights of Nature & Future Generations",
    ],
  },
  {
    name: "Alternative Finance Systems",
    color: "#D6CFEF",
    sub: [
      "Innovative Financial Instruments",
      "Transformative Capital",
      "Complementary Currency Systems",
      "Community Finance Institutions",
      "Alternative Economic Valuation Approaches",
    ],
  },
];

// Helper: strip "Main | Sub" or "Main [Other]" into {main, sub}
export function parseTypologyTag(tag) {
  if (!tag) return null;
  const t = tag.replace(/\s+/g, ' ').trim();
  const m = t.match(/^(.*?)\s*[\|\[]/);
  const main = m ? m[1].trim() : t;
  const subMatch = t.match(/\|\s*(.+)$/);
  let sub = subMatch ? subMatch[1].trim() : null;
  if (sub) sub = sub.replace(/\)$/, '').trim();
  return { main, sub };
};

// Normalize main category names used in CSV to match our typology
export function normalizeMainActivity(name) {
  const map = {
    "Activism & Advocacy": "Activism & Advocacy",
    "Demonstration": "Demonstration",
    "Scaling & Diffusing": "Scaling & Diffusing",
    "Communications & Narrative Change": "Communications & Narrative Change",
    "Research & Knowledge Generation": "Research & Knowledge Generation",
    "Funding & Resource Mobilisation": "Funding & Resource Mobilisation",
    "Capacity Building & Education": "Capacity Building & Education",
    "Movement Building & Organising": "Movement Building & Organising",
  };
  return map[name] || name;
};

export function normalizeMainTheme(name) {
  const map = {
    "Alternative Economic Models": "Alternative Economic Models",
    "Public Finance & Financial System Reform": "Public Finance & Financial System Reform",
    "Socio-Economic Security & Justice": "Socio-Economic Security & Justice",
    "Sectoral System Transformation": "Sectoral System Transformation",
    "Place-Based Resilience": "Place-Based Resilience",
    "Place-Based Transition & Resilience": "Place-Based Resilience",
    "Market Governance & Oversight": "Market Governance & Oversight",
    "Democratic Participation & Economic Democracy": "Democratic Participation & Economic Democracy",
    "Alternative Finance Systems": "Alternative Finance Systems",
  };
  return map[name] || name;
};
